import { Router } from 'express';
import { db } from '../storage';
import { ClassRoom } from '../../src/types';

export const classesRouter = Router();

// Get classes for specific teacher
classesRouter.get('/', (req, res) => {
  const teacherId = req.query.teacherId as string;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });
  const list = db.getClasses(teacherId);
  res.json(list);
});

// Create class
classesRouter.post('/', (req, res) => {
  const {
    teacherId,
    name,
    code,
    subject,
    grade,
    classType,
    roomOrLink,
    pricePerSession,
    pricePerMonth,
    pricePerStudentPerSession,
    teacherSharePercent,
    scheduleTemplate,
    color,
    notes
  } = req.body;

  if (!teacherId || !name) {
    return res.status(400).json({ error: 'Tên lớp học và ID giáo viên là bắt buộc' });
  }

  const newClass: ClassRoom = {
    id: `class_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
    teacherId,
    name,
    code: code || `LOP-${Math.floor(1000 + Math.random() * 9000)}`,
    subject: subject || 'Toán học',
    grade: grade || 'Lớp 9',
    classType: classType || 'offline',
    roomOrLink: roomOrLink || 'Phòng học',
    pricePerSession: Number(pricePerSession) || 350000,
    pricePerMonth: Number(pricePerMonth) || 1200000,
    pricePerStudentPerSession: pricePerStudentPerSession ? Number(pricePerStudentPerSession) : undefined,
    teacherSharePercent: teacherSharePercent !== undefined ? Number(teacherSharePercent) : 100,
    scheduleTemplate: scheduleTemplate || [],
    color: color || '#059669',
    active: true,
    notes: notes || '',
    createdAt: new Date().toISOString()
  };

  db.createClass(newClass);
  // Auto sync sessions to teacher's personal schedule
  const syncedSessionsCount = db.syncClassToSchedule(teacherId, newClass);

  res.json({
    ...newClass,
    syncedSessionsCount,
    message: `Đã tạo lớp ${newClass.name} và tự động thêm ${syncedSessionsCount} buổi học vào Thời khóa biểu cá nhân của bạn!`
  });
});

// Update class
classesRouter.put('/:id', (req, res) => {
  const { id } = req.params;
  const { teacherId, autoSyncSchedule, ...updates } = req.body;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const updated = db.updateClass(teacherId, id, updates);
  if (!updated) return res.status(404).json({ error: 'Không tìm thấy lớp học' });

  let syncedSessionsCount = 0;
  if (autoSyncSchedule !== false && updated.scheduleTemplate?.length) {
    syncedSessionsCount = db.syncClassToSchedule(teacherId, updated);
  }

  res.json({
    ...updated,
    syncedSessionsCount,
    message: syncedSessionsCount > 0
      ? `Đã cập nhật lớp và đồng bộ thêm ${syncedSessionsCount} buổi học vào Thời khóa biểu!`
      : `Đã cập nhật thông tin lớp học!`
  });
});

// Delete class
classesRouter.delete('/:id', (req, res) => {
  const { id } = req.params;
  const teacherId = req.query.teacherId as string;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const success = db.deleteClass(teacherId, id);
  res.json({ success });
});
